import './App.css';
import WeatherApp from './WeatherApp';
function App() {
  return (
    <div className="App">
      <WeatherApp />
    </div>
  );
}

export default App;
